<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showInterest") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <div class="row">
        <!-- Start:: Interest Info -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.interest_name_ar')"
          v-model.trim="data.name_ar"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.interest_name_en')"
          v-model.trim="data.name_en"
          disabled
        />

        <base-picker-input
          col="6"
          type="date"
          :placeholder="$t('PLACEHOLDERS.created_at')"
          v-model.trim="data.created_at"
          disabled
        />

        <!-- Start:: Status Switch Input -->
        <div class="input_wrapper switch_wrapper my-5 col-6">
          <v-switch
            color="green"
            :label="
              data.is_active
                ? $t('PLACEHOLDERS.active')
                : $t('PLACEHOLDERS.notActive')
            "
            v-model="data.is_active"
            hide-details
            disabled
          ></v-switch>
        </div>
        <!-- End:: Status Switch Input -->
      </div>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowInterest",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        is_active: null,
        created_at: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: Show Data
    async showInterest() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `interests/${this.$route.params?.id}`,
        });
        
        const interestData = res.data.data.Interest;
        this.data.name_ar = interestData.name_ar;
        this.data.name_en = interestData.name_en;
        this.data.is_active = interestData.is_active;
        this.data.created_at = interestData.created_at;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Show Data
  },

  created() {
    this.showInterest();
  },
};
</script>